<div style="padding: 0 20px 20px 20px" class="property_tags_container">
    <h4>Property Promotion Tags</h4>
    <div fxLayout="row wrap" fxLayoutAlign="space-between start">
        <mat-checkbox *ngFor="let tag of propertyPromotionTags" [checked]="isCheckBoxSelected(tag.id)"
            (change)="select($event, tag.id)"
            style="width: 30%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.2);margin-bottom: 16px;">
            {{tag.notes.en}}
        </mat-checkbox>
    </div>

    <h5>Ammenities</h5>
    <p>Indoor features</p>
    <div fxLayout="row wrap" fxLayoutAlign="start" class="tags-property">
        <mat-checkbox *ngFor="let tag of indoor" [checked]="isCheckBoxSelected(tag.id)"
            (change)="select($event, tag.id)" style="width: 18%">
            {{tag.notes.en}}
        </mat-checkbox>
    </div>

    <p>Outdoor features</p>
    <div fxLayout="row wrap" fxLayoutAlign="start" class="tags-property">
        <mat-checkbox *ngFor="let tag of outdoor" [checked]="isCheckBoxSelected(tag.id)"
            (change)="select($event, tag.id)" style="width: 18%">
            {{tag.notes.en}}
        </mat-checkbox>
    </div>

    <p>Energy features</p>
    <div fxLayout="row wrap" fxLayoutAlign="start" class="tags-property">
        <mat-checkbox *ngFor="let tag of energy" [checked]="isCheckBoxSelected(tag.id)"
            (change)="select($event, tag.id)" style="width: 18%">
            {{tag.notes.en}}
        </mat-checkbox>
    </div>

    <p>Public facilities features</p>
    <div fxLayout="row wrap" fxLayoutAlign="start" class="tags-property">
        <mat-checkbox *ngFor="let tag of publicFacilities" [checked]="isCheckBoxSelected(tag.id)"
            (change)="select($event, tag.id)" style="width: 18%">
            {{tag.notes.en}}
        </mat-checkbox>
    </div>
    <div class="flex justify-end">
        <button mat-button (click)="submit()"
            style="width: 163px;height: 52px;border: 1px solid #DEDEDE;border-radius: 8px;background-color: #161616;">Save</button>
    </div>
</div>